import { Content, Row, Col, Button, H1, H2, H3 } from 'components/common'
import { React, Image, styled, mq } from 'x'
import Arrow from 'static/svg/arrow.svg'

const Container = styled.div`
box-sizing: border-box;
  display: block;
  padding: 60px 30px;
  margin-left:auto;
  margin-right:auto;
  margin-top:0;
  margin-bottom:0;
`

const SectionContent = styled(Content)`
  margin-right: auto;
  margin-left: auto;
  box-sizing: border-box;
  padding: 0 30px;

  ${mq.below('lg')} {
    padding: 0 30px;
  }
  ${mq.below('md')} {
    padding: 0 30px;
  }
  ${mq.below('sm')} {
    padding: 0 15px;
  }
`

const Title = styled(H1)`
  max-width: 100%;
  color: #000;
  text-align:center;
  width: 100%;
  margin-top:0;
  margin-bottom: 30px;
  font-size:42px;
  line-height: 1.2;
  font-weight:800;
`

const Subtitle = styled(H2)`
  max-width: 100%;
  color: #000;
  text-align:center;
  width: 100%;
  margin-top:0;
  margin-bottom: 30px;
  font-size:36px;
  line-height:1.2;
  font-weight:600;
`

const Inner = styled.div`
  ${mq.above('lg')} {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
  
  box-sizing: border-box;
  margin-right: -30px;
  margin-left: -30px;
  margin-top:30px;
  margin-bottom:40px;
  display:flex;
  flex: 0 1 auto;
  flex-direction:column;
  align-items:stretch;
  align-content:stretch;
`

const Tile = styled.div`
  ${mq.above('lg')} {
    flex:1 1 33.3336%;
    max-width:33.3336%;
    margin-bottom:0;
  }
  box-sizing: border-box;
  flex:1 1 100%;
  max-width: 100%;
  padding:0 30px;
  margin-bottom:30px;
  align-items:center
`

const TileInner = styled.div`
  display:block;
  background-color: #fff;
  height:100%;
  box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.2);
`

const TileHeader = styled.div`
  padding:30px 15px;
  background-color:rgb(38, 48, 68);
  min-height:60px;
  display:flex;
  flex-direction: column;
  > span {
    content:' ';
    display:block;
    width:10px; 
    height:2px;
    background-color: rgb(255 201 74);
    margin-top:20px;
    margin-top:auto;
  }
`

const TileTitle =styled(H3) `
  color:#FFF;
  font-size:20px;
  font-weight:800;
  line-height:1.2;
  margin-top:0;
  margin-bottom:0;
`

const TileBody = styled.div`
  display:flex;
  border:1px solid rgb(38, 48, 68);
`

const TileContent =styled.div`
  color: rgb(38, 48, 68);
  flex:1 1 55%;
  text-align: left;
  padding:20px 15px;
  h4 {
    font-weight:800;
    margin-bottom:0;
    margin-top:0;
  }
  p {
    margin-top:0;
  }
`

const TileName = styled(H3)`  
  color: rgb(38, 48, 68);
  font-weight:800;
  line-height: 1.2;
  margin: 30px 0;
  margin-top:0;
`

const TileImgWrapper = styled.div `
  flex:1 1 45%;
  img, Image {
    margin:0 auto;
    width:100%;
    max-width: 100%;
    height:auto;
  }
`

const AnimatedButton = styled(Button)`
  margin:0 auto;
  height: 46px;
  line-height: 46px;
  min-width: 200px;
  font-size:20px;
  font-weight: 800;
  text-transform: capitalize;
  color: #FFF;
  background-color:rgb(38, 48, 68);
  & svg {
    transition: transform 0.3s;
    &.circle {
      background-color: #FFF;
      fill: rgb(38, 48, 68);
      opacity:0.7;
    }
  }
  &:hover {
    color: rgb(38, 48, 68);
    & svg {
      transform: translateX(10px);
      &.circle {
        opacity:1;
        fill: rgb(38, 48, 68);
      }
    }
  }

  ${mq.below('sm')} {
    min-width: auto;
  }
`

const Section = props => {
  const items = props.data.items
    ? props.data.items
    : [
        {
          image: props.data.items.image.imgixImageWp.fluid ,
          imageLocal: props.data.items.image.source_url,
          title: props.data.items.title,
          subtitle: props.data.items.subtitle,
        }
      ]

  const numTiles = items.length


  return (
    <Container style={{backgroundColor: props.data.bgColour || 'black' }}>
      <SectionContent>
        <Row>
          <Col>
            <Title>{props.data.title}</Title>
            <Subtitle>{props.data.subtitle}</Subtitle>
          </Col>
        </Row>
        <Inner index={props.index} numTiles={numTiles}>
          {items.map((item, index) => (
            <Tile key={'item-' + index}>
              <TileInner>
                <TileHeader>
                  {item.title && (<TileTitle>{item.title}</TileTitle>)}
                  <span> </span>
                </TileHeader>
                <TileBody>
                  <TileContent> 
                    {item.name && (<TileName>{item.name}</TileName>)}
                    <h4>FROM</h4>
                    <p>{item.from}</p>
                    <h4>TO</h4>
                    <p>{item.to}</p>
                  </TileContent>
                  <TileImgWrapper>
                    {item?.image?.imgixImageWp?.fluid && (
                        <Image
                          fluid={{ ...item.image.imgixImageWp.fluid, sizes: '100vw' }}
                        />
                    )}
                  </TileImgWrapper>
                </TileBody>
              </TileInner>
            </Tile>
          ))}
        </Inner>
        {props.data.ctaLabel && (
          <Row>
            <Col style={{textAlign: 'center'}}>
              <AnimatedButton to={props.data.ctaURL}>
                <span>{props.data.ctaLabel}</span>
                <Arrow className="circle" />
              </AnimatedButton>
            </Col>
          </Row>
        )}
      </SectionContent>
    </Container>
  )
}

export default Section
